import { getDb } from '../db';
import { SCHEMA_VERSION } from '../migrations';
import type { Meta } from '../../core/types';

const KEY = 'meta' as const;

function initialMeta(): Meta {
  return {
    schemaVersion: SCHEMA_VERSION,
    installedAt: new Date().toISOString(),
    persistGranted: null,
    installedToHomeScreen: null,
  };
}

/**
 * Install-level facts, including the `navigator.storage.persist()` result.
 *
 * `persistGranted: false` is recorded rather than retried away: the grant is
 * heuristic and can legitimately be refused (design §2.3), and a caregiver needs to
 * see it because it is the signal that backup has become the only durability
 * guarantee.
 */
export const metaRepo = {
  async get(): Promise<Meta> {
    const db = await getDb();
    const stored = await db.get('meta', KEY);
    if (stored) return { ...initialMeta(), ...stored };
    const fresh = initialMeta();
    await db.put('meta', fresh, KEY);
    return fresh;
  },

  async update(patch: Partial<Meta>): Promise<Meta> {
    const db = await getDb();
    const next: Meta = { ...(await this.get()), ...patch };
    await db.put('meta', next, KEY);
    return next;
  },
};
